import GameHelper from "@/utils/game-helper";
import {
  hasResultMismatch,
  initGames,
} from "vue-chess-shared/tournament/utils/gameUtils";

export default {
  data() {
    return {
      roundGames: [],
    };
  },

  watch: {
    games: {
      immediate: true,
      handler() {
        this.initRoundGames();
      },
    },
  },

  computed: {
    gameStats() {
      const total = this.roundGames.filter((g) => g.whiteUsername).length;
      const live = this.roundGames.filter(
        (g) => g.matchRef && g.matchRef.status === "live"
      ).length;
      const bye = this.roundGames.filter(
        (g) => g.whiteUsername && !g.blackUsername
      ).length;
      const matches = this.roundGames.filter((g) => g.matchRef).length;
      const unfinished = this.roundGames.filter((g) =>
        GameHelper.isUnfinished(g)
      ).length;
      const finished = this.roundGames.filter(
        (g) =>
          g.blackUsername &&
          !GameHelper.isUnfinished(g) &&
          !this.hasResultMismatch(g)
      ).length;
      const aborted = this.roundGames.filter(
        (g) => g.matchRef && g.matchRef.status === "aborted"
      ).length;
      const conflicted = this.roundGames.filter(
        (g) =>
          !GameHelper.isUnfinished(g) &&
          (this.hasResultMismatch(g) || GameHelper.hasPlayerMismatch(g))
      ).length;
      const bots = this.roundGames.filter(
        (g) =>
          g.whiteUsername &&
          g.blackUsername &&
          g.whiteUsername.startsWith("ai_") &&
          g.blackUsername.startsWith("ai_")
      ).length;
      const text = total
        ? `${bye} bye, ${finished} finished, ${unfinished} unfinished`
        : "0 game";
      return {
        total,
        live,
        bye,
        matches,
        unfinished,
        finished,
        aborted,
        conflicted,
        bots,
        text,
      };
    },
  },

  methods: {
    initRoundGames() {
      this.roundGames = this.games
        .filter((g) => g.roundNumber === this.round.roundNumber)
        .sort((a, b) => a.board - b.board)
        .map((g) => ({ ...g }));
      if (!this.roundGames.length) {
        this.roundGames = initGames(
          this.round.roundNumber,
          Math.ceil(this.players.length / 2)
        );
      }
    },

    hasResultMismatch(game) {
      if (!game) return false;
      return hasResultMismatch(game, game.matchRef);
    },
  },
};
